import React, { Component } from 'react'
import './_BackgroundPage.scss'
import {connect} from 'react-redux'
import CONFIG from 'base/constants/config';

class BackgroundPage extends Component {
  componentDidUpdate(prevProps, prevState) {
    if(this.props.SystemInfo !== prevProps.SystemInfo) {
      this.forceUpdate();
    }
  }
  render() {
    let {SystemInfo} = this.props
    return (
      <div className='container-background'>
        {SystemInfo && SystemInfo.themeInfo && (<div className='background-left' style={{backgroundImage: `url(${CONFIG.VITRADE_IMAGE_URL}/resize/500x500/fairs/download/${SystemInfo.themeInfo.backgroundLeft ? SystemInfo.themeInfo.backgroundLeft : ''})`}}></div>)}
        {SystemInfo && SystemInfo.themeInfo && (<div className='background-right' style={{backgroundImage: `url(${CONFIG.VITRADE_IMAGE_URL}/resize/500x500/fairs/download/${SystemInfo.themeInfo.backgroundRight ? SystemInfo.themeInfo.backgroundRight : ''})`}}></div>)}
      </div>
    );
  }
}

const bindStateToProps = (state) => {
  return {
    SystemInfo: state.System.data || {}
  };
};

export default connect(bindStateToProps)(BackgroundPage);


// WEBPACK FOOTER //
// ./components/home/sub-view/BackgroundPage.jsx